/**
 * "Safer" String.toLowerCase()
 */
var lowercase = function lowercase(str) {
  return str.toLowerCase();
};

export default lowercase;